<template lang="pug">
    div
        b-modal(:id="'search_high_school' + multi_field_num" size="lg" ok-only ok-title="Close")
            div(slot="modal-header")
                big
                    | Search for a High School
            div
                label(:for="'hs-country' + multi_field_num") Country
                b-form-select(:id="'hs-country' + multi_field_num" v-model="country" :options="country_options" @change="on_change")
                label(:for="'hs-name' + multi_field_num") High School Name
                b-form-input(:id="'hs-name' + multi_field_num" v-model="name" type="text" @change="on_change")
                label(:for="'hs-state' + multi_field_num") {{ state_label }}
                b-form-input(:id="'hs-state' + multi_field_num" v-model="state" type="text" @change="on_change")
                label(:for="'hs-city' + multi_field_num") City
                b-form-input(:id="'hs-city' + multi_field_num" v-model="city" type="text" @change="on_change")
            b-alert(:show="error.length > 0" variant="warning")
                | {{ error }}
            b-table(:id="'tbl_search_high_school_' + multi_field_num" striped hover :items="items" :fields="fields" :sort-by.sync="sortBy" :per-page="10" :current-page="current_page")
                template(slot="name" slot-scope="data")
                    b-link(href="#" @click="select_row(country, data.item.name, data.item.city, data.item.state, data.item.atp_cd)")
                        | {{ data.item.name }}
            b-pagination(v-model="current_page" :per-page="10" :total-rows="items.length")
</template>

<script>
export default {
	props: ["multi_field_num"],
	data() {
		return {
			current_page: 1,
			error: "",
			name: "",
			state: "",
			city: "",
			country: "USA",
			country_options: [
				{
					text: "USA",
					value: "USA"
				},
				{
					text: "Canada",
					value: "CAN"
				}
			],
			items: [],
			sortBy: "name",
			fields: [
				{ key: "name", label: "High School Name", sortable: true },
				{ key: "city", sortable: true },
				{ key: "state", label: this.state_label, sortable: true }
			]
		};
	},
	computed: {
		filter() {
			return {
				name: this.name,
				state: this.state,
				city: this.city,
				country: this.country
			};
		},
		state_label() {
			if (this.country === "CAN") {
				return "Province";
			}

			return "State";
		}
	},
	methods: {
		on_change() {
			let v = this;
			v.$axios
				.get("/question/high_school", {
					params: v.filter
				})
				.then(function(response) {
					v.error = "";
					v.items = response.data;
				})
				.catch(function() {
					v.error = "No High Schools found";
					v.items = [];
				});
		},
		select_row(country, name, city, state, atp_cd) {
			let this_state = "";
			let this_province = "";
			if (country === "USA") {
				this_state = state;
			} else if (country === "CAN") {
				this_province = state;
			}

			this.$store.dispatch(
				"q_high_school/process_mass_field_change",
				{
					parent_slug: "q_high_school",
					item_num: this.multi_field_num,
					fields: [
						{
							q_slug: "q_high_school_name",
							answer: name
						},
						{
							q_slug: "q_high_school_city",
							answer: city
						},
						{
							q_slug: "q_high_school_country",
							answer: country
						},
						{
							q_slug: "q_high_school_state",
							answer: this_state
						},
						{
							q_slug: "q_high_school_province",
							answer: this_province
						},
						{
							q_slug: "q_high_school_atp_cd",
							answer: atp_cd
						}
					]
				},
				{ root: true }
			);

			this.$root.$emit(
				"bv::hide::modal",
				"search_high_school" + this.multi_field_num
			);
		}
	},
	watch: {
		country() {
			this.fields = [
				{ key: "name", label: "High School Name", sortable: true },
				{ key: "city", sortable: true },
				{ key: "state", label: this.state_label, sortable: true }
			];
			this.$root.$emit(
				"bv::refresh::table",
				"tbl_search_high_school_" + this.multi_field_num
			);
		}
	}
};
</script>

<style scoped></style>
